/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DocusignEnvelopeFragment = {
  readonly __typename: "DocusignEnvelope";
  readonly id: c.DocusignEnvelopeId;
  readonly initialSignerEmail: string;
  readonly initialSignerName: string;
  readonly createdDate: c.DateTimeString;
  readonly envelopeStatus: c.DocusignEnvelopeStatus;
};

export type CreateDocusignEnvelopeMutationVariables = Types.Exact<{
  envelopeType: Types.Scalars["DocusignEnvelopeType"]["input"];
  initialSignerEmail: Types.Scalars["String"]["input"];
  initialSignerName: Types.Scalars["String"]["input"];
  voidPreviousEnvelope: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type CreateDocusignEnvelopeMutation = {
  readonly __typename: "Mutation";
  readonly createDocusignEnvelope: {
    readonly __typename: "DocusignEnvelope";
    readonly id: c.DocusignEnvelopeId;
    readonly initialSignerEmail: string;
    readonly initialSignerName: string;
    readonly createdDate: c.DateTimeString;
    readonly envelopeStatus: c.DocusignEnvelopeStatus;
  } | null;
};

export type GetActiveDocusignEnvelopeForEnvelopeTypeQueryVariables =
  Types.Exact<{
    envelopeType: Types.Scalars["DocusignEnvelopeType"]["input"];
    orgId: Types.Scalars["OrgId"]["input"];
  }>;

export type GetActiveDocusignEnvelopeForEnvelopeTypeQuery = {
  readonly __typename: "Query";
  readonly getActiveDocusignEnvelopeForEnvelopeType: {
    readonly __typename: "DocusignEnvelope";
    readonly id: c.DocusignEnvelopeId;
    readonly initialSignerEmail: string;
    readonly initialSignerName: string;
    readonly createdDate: c.DateTimeString;
    readonly envelopeStatus: c.DocusignEnvelopeStatus;
  } | null;
};

export type ActiveDocusignEnvelopeUpdatedSubscriptionVariables = Types.Exact<{
  envelopeType: Types.Scalars["DocusignEnvelopeType"]["input"];
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type ActiveDocusignEnvelopeUpdatedSubscription = {
  readonly __typename: "Subscription";
  readonly activeDocusignEnvelopeUpdated: {
    readonly __typename: "DocusignEnvelope";
    readonly id: c.DocusignEnvelopeId;
    readonly initialSignerEmail: string;
    readonly initialSignerName: string;
    readonly createdDate: c.DateTimeString;
    readonly envelopeStatus: c.DocusignEnvelopeStatus;
  } | null;
};

export type GetOrgForMagicTosQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetOrgForMagicTosQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly createdDate: c.DateTimeString;
    readonly isSelfServe: boolean;
    readonly envelopeCompletionOverrides: c.OrgEnvelopeCompletionOverrides | null;
    readonly envelopeExistsAggregate: c.OrgEnvelopeExistsAggregate;
  };
};

export const DocusignEnvelopeFragmentDoc = /*#__PURE__*/ gql`
  fragment DocusignEnvelopeFragment on DocusignEnvelope {
    id
    initialSignerEmail
    initialSignerName
    createdDate
    envelopeStatus
  }
`;
export const CreateDocusignEnvelopeDocument = /*#__PURE__*/ gql`
  mutation CreateDocusignEnvelope(
    $envelopeType: DocusignEnvelopeType!
    $initialSignerEmail: String!
    $initialSignerName: String!
    $voidPreviousEnvelope: Boolean
  ) {
    createDocusignEnvelope(
      envelopeType: $envelopeType
      initialSignerEmail: $initialSignerEmail
      initialSignerName: $initialSignerName
      voidPreviousEnvelope: $voidPreviousEnvelope
    ) {
      ...DocusignEnvelopeFragment
    }
  }
  ${DocusignEnvelopeFragmentDoc}
`;
export type CreateDocusignEnvelopeMutationFn = Apollo.MutationFunction<
  CreateDocusignEnvelopeMutation,
  CreateDocusignEnvelopeMutationVariables
>;

/**
 * __useCreateDocusignEnvelopeMutation__
 *
 * To run a mutation, you first call `useCreateDocusignEnvelopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocusignEnvelopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocusignEnvelopeMutation, { data, loading, error }] = useCreateDocusignEnvelopeMutation({
 *   variables: {
 *      envelopeType: // value for 'envelopeType'
 *      initialSignerEmail: // value for 'initialSignerEmail'
 *      initialSignerName: // value for 'initialSignerName'
 *      voidPreviousEnvelope: // value for 'voidPreviousEnvelope'
 *   },
 * });
 */
export function useCreateDocusignEnvelopeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDocusignEnvelopeMutation,
    CreateDocusignEnvelopeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDocusignEnvelopeMutation,
    CreateDocusignEnvelopeMutationVariables
  >(CreateDocusignEnvelopeDocument, options);
}
export type CreateDocusignEnvelopeMutationHookResult = ReturnType<
  typeof useCreateDocusignEnvelopeMutation
>;
export type CreateDocusignEnvelopeMutationResult =
  Apollo.MutationResult<CreateDocusignEnvelopeMutation>;
export type CreateDocusignEnvelopeMutationOptions = Apollo.BaseMutationOptions<
  CreateDocusignEnvelopeMutation,
  CreateDocusignEnvelopeMutationVariables
>;
export const GetActiveDocusignEnvelopeForEnvelopeTypeDocument = /*#__PURE__*/ gql`
  query GetActiveDocusignEnvelopeForEnvelopeType(
    $envelopeType: DocusignEnvelopeType!
    $orgId: OrgId!
  ) {
    getActiveDocusignEnvelopeForEnvelopeType(
      envelopeType: $envelopeType
      orgId: $orgId
    ) {
      ...DocusignEnvelopeFragment
    }
  }
  ${DocusignEnvelopeFragmentDoc}
`;

/**
 * __useGetActiveDocusignEnvelopeForEnvelopeTypeQuery__
 *
 * To run a query within a React component, call `useGetActiveDocusignEnvelopeForEnvelopeTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveDocusignEnvelopeForEnvelopeTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveDocusignEnvelopeForEnvelopeTypeQuery({
 *   variables: {
 *      envelopeType: // value for 'envelopeType'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetActiveDocusignEnvelopeForEnvelopeTypeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetActiveDocusignEnvelopeForEnvelopeTypeQuery,
    GetActiveDocusignEnvelopeForEnvelopeTypeQueryVariables
  > &
    (
      | {
          variables: GetActiveDocusignEnvelopeForEnvelopeTypeQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetActiveDocusignEnvelopeForEnvelopeTypeQuery,
    GetActiveDocusignEnvelopeForEnvelopeTypeQueryVariables
  >(GetActiveDocusignEnvelopeForEnvelopeTypeDocument, options);
}
export function useGetActiveDocusignEnvelopeForEnvelopeTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActiveDocusignEnvelopeForEnvelopeTypeQuery,
    GetActiveDocusignEnvelopeForEnvelopeTypeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetActiveDocusignEnvelopeForEnvelopeTypeQuery,
    GetActiveDocusignEnvelopeForEnvelopeTypeQueryVariables
  >(GetActiveDocusignEnvelopeForEnvelopeTypeDocument, options);
}
export function useGetActiveDocusignEnvelopeForEnvelopeTypeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActiveDocusignEnvelopeForEnvelopeTypeQuery,
    GetActiveDocusignEnvelopeForEnvelopeTypeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetActiveDocusignEnvelopeForEnvelopeTypeQuery,
    GetActiveDocusignEnvelopeForEnvelopeTypeQueryVariables
  >(GetActiveDocusignEnvelopeForEnvelopeTypeDocument, options);
}
export type GetActiveDocusignEnvelopeForEnvelopeTypeQueryHookResult =
  ReturnType<typeof useGetActiveDocusignEnvelopeForEnvelopeTypeQuery>;
export type GetActiveDocusignEnvelopeForEnvelopeTypeLazyQueryHookResult =
  ReturnType<typeof useGetActiveDocusignEnvelopeForEnvelopeTypeLazyQuery>;
export type GetActiveDocusignEnvelopeForEnvelopeTypeSuspenseQueryHookResult =
  ReturnType<typeof useGetActiveDocusignEnvelopeForEnvelopeTypeSuspenseQuery>;
export type GetActiveDocusignEnvelopeForEnvelopeTypeQueryResult =
  Apollo.QueryResult<
    GetActiveDocusignEnvelopeForEnvelopeTypeQuery,
    GetActiveDocusignEnvelopeForEnvelopeTypeQueryVariables
  >;
export const ActiveDocusignEnvelopeUpdatedDocument = /*#__PURE__*/ gql`
  subscription ActiveDocusignEnvelopeUpdated(
    $envelopeType: DocusignEnvelopeType!
    $orgId: OrgId!
  ) {
    activeDocusignEnvelopeUpdated(envelopeType: $envelopeType, orgId: $orgId) {
      ...DocusignEnvelopeFragment
    }
  }
  ${DocusignEnvelopeFragmentDoc}
`;

/**
 * __useActiveDocusignEnvelopeUpdatedSubscription__
 *
 * To run a query within a React component, call `useActiveDocusignEnvelopeUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useActiveDocusignEnvelopeUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveDocusignEnvelopeUpdatedSubscription({
 *   variables: {
 *      envelopeType: // value for 'envelopeType'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useActiveDocusignEnvelopeUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ActiveDocusignEnvelopeUpdatedSubscription,
    ActiveDocusignEnvelopeUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: ActiveDocusignEnvelopeUpdatedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ActiveDocusignEnvelopeUpdatedSubscription,
    ActiveDocusignEnvelopeUpdatedSubscriptionVariables
  >(ActiveDocusignEnvelopeUpdatedDocument, options);
}
export type ActiveDocusignEnvelopeUpdatedSubscriptionHookResult = ReturnType<
  typeof useActiveDocusignEnvelopeUpdatedSubscription
>;
export type ActiveDocusignEnvelopeUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<ActiveDocusignEnvelopeUpdatedSubscription>;
export const GetOrgForMagicTosDocument = /*#__PURE__*/ gql`
  query GetOrgForMagicTOS($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      createdDate
      isSelfServe
      envelopeCompletionOverrides
      envelopeExistsAggregate
    }
  }
`;

/**
 * __useGetOrgForMagicTosQuery__
 *
 * To run a query within a React component, call `useGetOrgForMagicTosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgForMagicTosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgForMagicTosQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgForMagicTosQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrgForMagicTosQuery,
    GetOrgForMagicTosQueryVariables
  > &
    (
      | { variables: GetOrgForMagicTosQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrgForMagicTosQuery,
    GetOrgForMagicTosQueryVariables
  >(GetOrgForMagicTosDocument, options);
}
export function useGetOrgForMagicTosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrgForMagicTosQuery,
    GetOrgForMagicTosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrgForMagicTosQuery,
    GetOrgForMagicTosQueryVariables
  >(GetOrgForMagicTosDocument, options);
}
export function useGetOrgForMagicTosSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrgForMagicTosQuery,
    GetOrgForMagicTosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrgForMagicTosQuery,
    GetOrgForMagicTosQueryVariables
  >(GetOrgForMagicTosDocument, options);
}
export type GetOrgForMagicTosQueryHookResult = ReturnType<
  typeof useGetOrgForMagicTosQuery
>;
export type GetOrgForMagicTosLazyQueryHookResult = ReturnType<
  typeof useGetOrgForMagicTosLazyQuery
>;
export type GetOrgForMagicTosSuspenseQueryHookResult = ReturnType<
  typeof useGetOrgForMagicTosSuspenseQuery
>;
export type GetOrgForMagicTosQueryResult = Apollo.QueryResult<
  GetOrgForMagicTosQuery,
  GetOrgForMagicTosQueryVariables
>;
